// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input } from '@angular/core';
import { MenuItem } from '../../../models/menu-item';
import { DateRangeFilter } from '@coa/app/shared/filters/select-date-range/models/date-range-filter';
import { FeatureToggle } from '@coa/app/shared/feature-toggle/models/feature.toggle';

@Component({
  selector: 'coa-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent {
  @Input() clientId: string;
  @Input() dateRange: DateRangeFilter;
  @Input() showLabels = true;

  menuItems: MenuItem[] = [
    {url: 'dashboard', name: 'Dashboard', icon: 'dashboard', featureToggle: undefined},
    {url: 'stores', name: 'Stores', icon: 'store', featureToggle: undefined},
    {url: 'groups', name: 'Groups', icon: 'view_module', featureToggle: FeatureToggle.DYNAMIC_GROUPS_ENABLED},
    {url: 'floors', name: 'Floors', icon: 'stairs', featureToggle: FeatureToggle.FLOORS_VIEW_ENABLED},
    {url: 'compare', name: 'Compare', icon: 'compare_arrows', featureToggle: undefined},
  ];
}
